import React from 'react';
import { RestrictedGroup } from '../../../restricted-words-next/restrictedWordsTypes';

import styles from './ArticleItemGroups.module.scss';

const MAX_GROUPS_IN_ROW = 4;

interface ArticleItemGroupsProps {
  groups: RestrictedGroup[];
}

export const ArticleItemGroups = ({ groups = [] }: ArticleItemGroupsProps) => {
  const isEmpty = groups.length === 0;
  const groupsAmount = groups.length - MAX_GROUPS_IN_ROW;
  const shouldRenderGroupsAmount = groupsAmount > 0;

  return (
    <span className={styles.container}>
      {isEmpty && <span className={styles.empty}>None</span>}
      {groups?.slice(0, MAX_GROUPS_IN_ROW).map(group => {
        return (
          <div key={group.id} className={styles.item}>
            <span className={styles.name}>{group.value}</span>
          </div>
        );
      })}
      {shouldRenderGroupsAmount && <span className={styles.groupAmount}>+{groupsAmount}</span>}
    </span>
  );
};
